import React from 'react';
import { Field } from 'redux-form';
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField';
import { isPresent } from 'utils/isPresent';

export const normalizePhone = (value, previousValue) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      return onlyNums + '-';
    }
    if (onlyNums.length === 6) {
      return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3) + '-';
    }
  }
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 6) {
    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
  }
  return (
    onlyNums.slice(0, 3) +
    '-' +
    onlyNums.slice(3, 6) +
    '-' +
    onlyNums.slice(6, 10)
  );
};

export const normalizeZip = (value, previousValue) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, '');
  if (onlyNums.length > 5) {
    return onlyNums.slice(0, 5);
  }

  return value;
};

const normalizeInt = (value, previousValue) => {
  if (!value) {
    return value;
  }
  return value.replace(/[^\d]/g, '');
};

const maxLength = (count) => (value) => {
  if (value && value.length < count) {
    return value;
  }
};

const FormTextField = (props) => {
  const { normalize, ...theRest } = props;

  var normalizer;
  if (normalize === 'phone') {
    normalizer = normalizePhone;
  } else if (normalize === 'zip') {
    normalizer = normalizeZip;
  } else if (normalize === '40Max') {
    normalizer = maxLength(40);
  } else if (normalize === 'int') {
    normalizer = normalizeInt;
  }
  return (
    <Field component={renderTextField} normalize={normalizer} {...theRest} />
  );
};

export const renderTextField = ({
  input,
  fullWidth,
  helperText,
  meta: { touched, error },
  endAdornment,
  ...custom
}) => {
  return (
    <TextField
      fullWidth={isPresent(fullWidth) ? fullWidth : false}
      error={touched && isPresent(error)}
      helperText={
        touched && typeof error == 'string' && error.length > 0
          ? error
          : helperText || ''
      }
      InputProps={{
        endAdornment: endAdornment,
      }}
      {...custom}
      {...input}
    />
  );
};

FormTextField.defaultProps = {
  variant: 'filled',
};

export default FormTextField;
